import { Vue } from 'vue-property-decorator'

export const invoiceSettlementType = () => {
  return {
    EXEMPTION: { number: 50380001, label: Vue.prototype.$gettext('EXEMPTION') },
    TOTAL_WRITE_OFF: { number: 50380002, label: Vue.prototype.$gettext('TOTAL_WRITE_OFF') },
    PARTIAL_WRITE_OFF: { number: 50380003, label: Vue.prototype.$gettext('PARTIAL_WRITE_OFF') },
    PARTIAL_LOSS: { number: 50380004, label: Vue.prototype.$gettext('PARTIAL_LOSS') },
    TOTAL_LOSS: { number: 50380005, label: Vue.prototype.$gettext('TOTAL_LOSS') }
  }
}
